module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4 flex flex-wrap outer"
  }, [_c('div', {
    staticClass: "flex flex-column tc bg-white new-shadow-theme br3 w-100 ph4 main-container",
    class: [
      !_vm.isSomeComplete && 'h-100',
      _vm.showSavings && 'border-annual'
    ]
  }, [(!_vm.isSomeComplete) ? _c('no-device-data') : _c('div', {
    staticClass: "flex flex-column flex-direction h-100 justify-between content"
  }, [_c('div', {
    class: _vm.showSavings ? 'quote-contents' : ''
  }, [_c('div', {
    staticClass: "flex flex-row w-100 items-center justify-between h2 mb4"
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f4-ns black tl"
  }, [_vm._v("\n            Your Quote\n          ")]), _vm._v(" "), (!_vm.disableIntervalToggle) ? _c('div', [_c('plan-type-toggle', {
    attrs: {
      "disabled": _vm.partnerDevices.length > 0,
      "setValue": _vm.setMonthly,
      "toggleValue": _vm.monthlyToggle,
      "customClass": "mt4 mb4",
      "firstOption": "Monthly",
      "secondOption": "Annual",
      "toggleName": "monthlyToggle"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('summary-price', {
    attrs: {
      "billedFrecuency": _vm.monthlyToggle ? 'month' : 'year',
      "billedPrice": _vm.commonPrice,
      "deductibles": _vm.generalDeductibles,
      "isMonthly": _vm.monthlyToggle,
      "isPhoneOnly": _vm.isPhoneOnly,
      "planName": _vm.name,
      "pricePerMonth": _vm.monthlyToggle ? _vm.commonPrice : _vm.yearlyPrice,
      "totalDeductibles": _vm.totalDeductibles
    }
  }), _vm._v(" "), _vm._l((_vm.phoneModelsWithCount), function(deviceInfo, index) {
    return _c('device-info-3c-vue', {
      key: index,
      attrs: {
        "deviceInfo": deviceInfo,
        "getCoveragePhoneOnly": _vm.getCoverage,
        "index": index,
        "isMonthly": _vm.monthlyToggle,
        "isPhoneOnly": _vm.isPhoneOnly,
        "phoneModels": _vm.phoneModels
      }
    })
  }), _vm._v(" "), _c('discount-message', {
    attrs: {
      "isApplied": _vm.phoneModels.length > 1,
      "isPhoneOnly": _vm.isPhoneOnly
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "mt4 center w-100",
    class: _vm.showSavings ? 'proceed-annual' : ''
  }, [_c('VTooltip', {
    attrs: {
      "disabled": !_vm.disabled,
      "placement": "bottom"
    },
    scopedSlots: _vm._u([{
      key: "popper",
      fn: function() {
        return [_c('span', {
          staticClass: "inter f7"
        }, [_vm._v("\n              Please complete device information to proceed\n            ")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', [_c('ak-button', {
    attrs: {
      "newDisabled": _vm.disabled,
      "newPrimary": !_vm.monthlyToggle,
      "newSecondary": _vm.monthlyToggle,
      "block": "",
      "customClass": "button-custom"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.conversionCaption) + "\n        ")])], 1)])], 1)])], 1), _vm._v(" "), (_vm.showSavings) ? _c('div', {
    staticClass: "f4 bg-theme white tc pv3 flex savings-banner"
  }, [_c('strong', [_vm._v("SAVE $" + _vm._s(_vm.savings.toLocaleString()) + "!")])]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt3 silver lh-copy f6 tc w-100 mb4"
  }, [_c('div', [_vm._v("\n      Upgrade, downgrade, or cancel anytime • Prorated adjustments & refunds\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2025e959","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/summaryBox/NewSummaryCard3c.vue
// module id = 723
// module chunks = 0